/**
 * Mapeo `tipoEvento` de notificación → rol-contexto del docente (ADR 054).
 *
 * Sirve para: (a) encender el punto "nuevo" del sidebar sobre "Asesorías" /
 * "Jurado" cuando hay una notificación NO LEÍDA de ese rol, y (b) marcar esas
 * notificaciones como leídas al abrir la bandeja correspondiente (apaga el punto).
 *
 * Son strings (la notificación no lleva un campo "rol"); la lista se mantiene
 * acá, alineada con los `notificaciones.encolar(...)` del backend.
 */
export const TIPOS_NOTIF_ASESOR: ReadonlySet<string> = new Set([
  "SOLICITUD_ASESORIA_CREADA", // un estudiante te propone como asesor (handshake)
  "DESIGNACION_ASESOR", // el Decanato te designó asesor
  "ENVIO_PROYECTO_A_REVISION", // tu asesorado envió el proyecto a tu revisión
]);

export const TIPOS_NOTIF_JURADO: ReadonlySet<string> = new Set([
  "DESIGNACION_JURADO", // el Decanato te designó miembro del jurado
]);
